/* global Provider */
import React, { Component, useEffect, useState } from 'react';
import { LineChart, XAxis, YAxis, Tooltip, CartesianGrid, Legend, Line, ResponsiveContainer, ReferenceLine, ReferenceArea, LabelList, ScatterChart, Scatter, Cell, ZAxis, Dot } from 'recharts';
import Num from '../util/NumberUtil.js';
import Colors from '../util/Colors.js';
import { Select, Button } from 'antd';
import _ from 'underscore';
var d3 = require('d3-shape');
const { Option } = Select;
var globalIndex = 0
var counter = 0;
var lastX = 0;
var lastY = 0;
let totalLarge = 0
let tickerLookup = {}


const CustomTooltip = ({ position, content, onMouseEnter, onMouseLeave }) => {
    const { x, y } = position || {};

    return (
        <div
            className="custom-tooltip"
            style={{ left: x + 5, top: y + 5 }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {content}
        </div>
    );
};

const Content = ({ item }) => {
    //console.log("received item:", item);
    return (
        <div>
            <div>
                <span>{item.display}</span>
            </div>
            <div>
                <span>Drawdown:</span>
                <span>{item.Drawdown_X}%</span>
            </div>
            <div>
                <span>Growth:</span>
                <span>{item.Growth_Y}%</span>
            </div>
        </div>
    );
};




const CustomizedLabel = (props) => {


	const { x, y, fill, display, index } = props;


    if (fill === '#000000') {
		return null
    }

	let anchor = "middle"

    let lineStartX = x;
    let lineStartY = y;
    let lineEndX = x;
    let lineEndY = y;

    let textPositionX = lineEndX;
    let textPositionY = lineEndY;

    console.log("{ id: "+index+", display: '"+display+"', lineStartX: "+lineStartX+", lineStartY: "+lineStartY+", lineEndX: "+lineEndX+", lineEndY: "+lineEndY+", textPositionX: "+textPositionX+", textPositionY: "+textPositionY+"},");
    

    const labelDataArray = [
        { id: 0, display: 'FlexPath Index+ Conservative', lineStartX: 2, lineStartY: 0, lineEndX: 5, lineEndY: -70, textPositionX: 20, textPositionY: -70},
        { id: 1, display: 'BlackRock LifePath Index Conserv', lineStartX: 2, lineStartY: 0, lineEndX: 25, lineEndY: -30, textPositionX: 60, textPositionY: -30},
        { id: 2, display: 'Putnam Sustainable Retirement', lineStartX: 2, lineStartY: 0, lineEndX: -5, lineEndY: -14, textPositionX: 0, textPositionY: -15},
        { id: 3, display: 'Putnam Retirement Advantage', lineStartX: 2, lineStartY: 0, lineEndX: -10, lineEndY: -20 , textPositionX: -20, textPositionY: -20},
        { id: 4, display: 'John Hancock Preservation Blend', lineStartX: 2, lineStartY: 0, lineEndX: 5, lineEndY: 10, textPositionX: 0, textPositionY: 20},
        { id: 5, display: 'Dimensional Target Date', lineStartX: 2, lineStartY: 5, lineEndX: 70, lineEndY: 0, textPositionX: 80, textPositionY: 0},
        { id: 6, display: 'American Century One Choice', lineStartX: 2, lineStartY: 0, lineEndX: -23, lineEndY: -15, textPositionX: -20, textPositionY: -15},
        { id: 7, display: 'Prudential Day One', lineStartX: 2, lineStartY: 0, lineEndX: 0, lineEndY: 15, textPositionX: 0, textPositionY: 25},
        { id: 8, display: 'MFS LifeTime', lineStartX: 2, lineStartY: 0, lineEndX: 40, lineEndY: 25, textPositionX: 67, textPositionY: 35},
        { id: 9, display: 'American Century One Choice Blend+', lineStartX: 2, lineStartY: 0, lineEndX: -20, lineEndY: -30, textPositionX: -20, textPositionY: -30},
        { id: 10, display: 'MassMutual RetireSMART by JPM', lineStartX: 2, lineStartY: 0, lineEndX: 40, lineEndY: 25, textPositionX: 67, textPositionY: 35},
        { id: 11, display: 'Voya Index Solution', lineStartX: 2, lineStartY: 5, lineEndX: 40, lineEndY: 25, textPositionX: 67, textPositionY: 35},
        { id: 12, display: 'Transamerica ClearTrack Target Date', lineStartX: 0, lineStartY: 0, lineEndX: -130, lineEndY: -50, textPositionX: -135, textPositionY: -50},
        { id: 13, display: 'Voya Solution', lineStartX: 2, lineStartY: 0, lineEndX: 40, lineEndY: 10, textPositionX: 67, textPositionY: 20},
        { id: 14, display: 'T. Rowe Price Target', lineStartX: 2, lineStartY: 0, lineEndX: -70, lineEndY: -70, textPositionX: -85, textPositionY: -70},
        { id: 15, display: 'FlexPath Index+ Moderate', lineStartX: 2, lineStartY: 0, lineEndX: -90, lineEndY: -125, textPositionX: -60, textPositionY: -125},
        { id: 16, display: 'BNYM Newton SmartPath', lineStartX: 2, lineStartY: 2, lineEndX: -110, lineEndY: -130, textPositionX: -110, textPositionY: -130},
        { id: 17, display: 'Nationwide Destination', lineStartX: 2, lineStartY: 0, lineEndX: 75, lineEndY: 130, textPositionX: 75, textPositionY: 140},
        { id: 18, display: 'BlackRock LifePath ESG Index', lineStartX: 2, lineStartY: 5, lineEndX: 55, lineEndY: 130, textPositionX: 110, textPositionY: 140},
        { id: 19, display: 'JPMorgan SmartRetirement Blend', lineStartX: 2, lineStartY: 2, lineEndX: 45, lineEndY: 60, textPositionX: 100, textPositionY: 70},
        { id: 20, display: 'Fidelity Freedom/Freedom Blend', lineStartX: 2, lineStartY: 0, lineEndX: 70, lineEndY: 130, textPositionX: 130, textPositionY: 135},
        { id: 21, display: 'YourPath Hybrid Moderate', lineStartX: 2, lineStartY: 2, lineEndX: -55, lineEndY: -70, textPositionX: -55, textPositionY: -70},
        { id: 22, display: 'JPMorgan SmartRetirement', lineStartX: 2, lineStartY: 0, lineEndX: 60, lineEndY: 50, textPositionX: 110, textPositionY: 60},
        { id: 23, display: 'BlackRock LifePath Index', lineStartX: 2, lineStartY: 2, lineEndX: 55, lineEndY: 40, textPositionX: 102, textPositionY: 50},
        { id: 24, display: 'Empower Lifetime', lineStartX: 2, lineStartY: 2, lineEndX: 65, lineEndY: 100, textPositionX: 100, textPositionY: 105},
        { id: 25, display: 'American Funds Target Date', lineStartX: 2, lineStartY: 0, lineEndX: 30, lineEndY: -50, textPositionX: 69, textPositionY: -50},
        { id: 26, display: 'AllianceBernstein Multi-Manager', lineStartX: 2, lineStartY: 0, lineEndX: -5, lineEndY: -105, textPositionX: 45, textPositionY: -105},
        { id: 27, display: 'Guidestone Funds MyDestination', lineStartX: 2, lineStartY: 0, lineEndX:-2, lineEndY: -92, textPositionX: 50, textPositionY: -92},
        { id: 28, display: 'Principal LifeTime Hybrid', lineStartX: 2, lineStartY: 2, lineEndX: 219, lineEndY: 48, textPositionX: 269, textPositionY: 55},
        { id: 29, display: 'Mutual of America Retirement', lineStartX: 2, lineStartY: 2, lineEndX: 229, lineEndY: 80, textPositionX: 239, textPositionY: 90},
        { id: 30, display: 'Schwab Target', lineStartX: 2, lineStartY: 2, lineEndX: 90, lineEndY: 35, textPositionX: 90, textPositionY: 45},
        { id: 31, display: 'Principal LifeTime', lineStartX: 2, lineStartY: 2, lineEndX: 239, lineEndY: 68, textPositionX: 276, textPositionY: 75},
        { id: 32, display: 'Fidelity Freedom Index', lineStartX: 2, lineStartY: 2, lineEndX: 180, lineEndY: 25, textPositionX: 222, textPositionY: 30},
        { id: 33, display: 'Vanguard Target Retirement', lineStartX: 2, lineStartY: 0, lineEndX: 0, lineEndY: -85, textPositionX: 45, textPositionY: -85},
        { id: 34, display: 'Schwab Target Index', lineStartX: 2, lineStartY: 0, lineEndX: 0, lineEndY: -74, textPositionX: 30, textPositionY: -74},
        { id: 35, display: 'State Street Target Retirement', lineStartX: 2, lineStartY: 0, lineEndX: 10, lineEndY: -60, textPositionX: 65, textPositionY: -60},
        { id: 36, display: 'PIMCO REALPATH Blend', lineStartX: 2, lineStartY: 2, lineEndX: 179, lineEndY: 35, textPositionX: 227, textPositionY: 40},
        { id: 37, display: 'TIAA-CREF Lifecycle Index', lineStartX: 2, lineStartY: 2, lineEndX: 140, lineEndY: -30, textPositionX: 170, textPositionY: -33},
        { id: 38, display: 'Natixis Sustainable Future', lineStartX: 2, lineStartY: 2, lineEndX: 180, lineEndY: 12, textPositionX: 230, textPositionY: 18},
        { id: 39, display: 'John Hancock Multimanager Lifetime', lineStartX: 2, lineStartY: 2, lineEndX: 90, lineEndY: 5, textPositionX: 155, textPositionY:9},
        { id: 40, display: 'Franklin LifeSmart', lineStartX: 2, lineStartY: 0, lineEndX: -3, lineEndY:-9, textPositionX: 20, textPositionY: -9},
        { id: 41, display: 'John Hancock Lifetime Blend', lineStartX: 2, lineStartY: 2, lineEndX: 80, lineEndY: -2, textPositionX: 130, textPositionY: 2},
        { id: 42, display: 'TIAA-CREF Lifecycle', lineStartX: 2, lineStartY: 0, lineEndX: 120, lineEndY: -12, textPositionX: 120, textPositionY: -12},
        { id: 43, display: 'Allspring Dynamic Target', lineStartX: 2, lineStartY: 2, lineEndX: 0, lineEndY: -68, textPositionX: 0, textPositionY: -68},
        { id: 44, display: 'T. Rowe Price Retirement', lineStartX: 2, lineStartY: 0, lineEndX: -80, lineEndY: -10, textPositionX:-80, textPositionY: -12},
        { id: 45, display: 'FlexPath Index+ Aggressive', lineStartX: 2, lineStartY: 0, lineEndX: -80, lineEndY: -30, textPositionX: -80, textPositionY: -32}   

      ];


      labelDataArray.forEach((theItem) => {
 
        if (index === theItem.id) {
          

            lineStartX = lineStartX + labelDataArray[index].lineStartX;
            lineStartY = lineStartY + labelDataArray[index].lineStartY;
            lineEndX = lineEndX + labelDataArray[index].lineEndX;
            lineEndY = lineEndY + labelDataArray[index].lineEndY;
        
            textPositionX = textPositionX + labelDataArray[index].textPositionX;
            textPositionY = textPositionY + labelDataArray[index].textPositionY;


          console.log(`Match found: ${labelDataArray[index].display}, ${display}, ${labelDataArray[index].lineStartX}, ${labelDataArray[index].lineEndX}`);
         
        }
      });


	return (
		<g>
			
			<line x1={lineStartX} y1={lineStartY} x2={lineEndX} y2={lineEndY} stroke={fill} />
			<text x={textPositionX} y={textPositionY} dy={-2} color={fill} fontSize={8} textAnchor={anchor}>
				{display}
            </text>
		</g>

	)
}

const GrowthChart = (props) => {

    

    const [showPicker, setShowPicker] = useState(false)
    const [selectedPoints, setSelectedPoints] = useState("")
    const [finalList, setFinalList] = useState([])
    const [yList, setYList] = useState([20,40,60,80,100])
    const [tooltip, setTooltip] = useState({});

	let tooltipTimeout;
    const showTooltip = (item, i, e) => {
        //console.log("show tooltip===0:", e);
        clearTimeout(tooltipTimeout);
        setTooltip({
            show: true,
            position: { x: item.cx, y: item.cy },
            content: <Content name={item.name} value={item.value} item={item} />
        });
    };

    const hideTooltip = (e) => {
        tooltipTimeout = setTimeout(() => setTooltip({ show: false, ...e }), 200);
    };

    const applySelection = () => {
        //console.log("this.state.selectedPoints===000:", selectedPoints);
        Provider.setSelectedPoints(selectedPoints)
        setShowPicker(false)
    }

    useEffect(() => {
        calculateFinalList()
    }, [props])

    useEffect(() => {
        calculateFinalList()
    }, [Provider.state])

    const calculateFinalList = () => {
        let fundsAlpha = _.sortBy(Provider.getOriginFunds(), (fund) => {
            return fund.label;
        });

        let providerState = Provider.state;
       	//console.log("provider state:", providerState);
        // providerState.weightings
        let allPoints = []
        if (providerState.responses != null) {
            if (providerState.responses[19] != null) {
                var weightings = providerState.weightings
                fundsAlpha.forEach((ele) => {
                    //console.log("funds element:", ele);
                    //console.log("weight element:", providerState.weightings);
                    ele.score = ele.Growth * weightings.Growth
                        + ele.Drawdown * weightings.Drawdown
                        + ele.Income * weightings.Income
                        + ele.Inflation * weightings.Inflation
                        + ele.Returns * weightings.Returns
                        + ele.Volatility * weightings.Volatility
                        + ele.Interest * weightings.Interest
                        + ele.Currency * weightings.Currency
                    allPoints.push({
						...ele
					})
                })
            }
        }
        //console.log("all points for chart:", allPoints);
        let scoreList = _.sortBy(allPoints, (point) => {
            return point.score
        })
        let selectedPoints = Provider.getSelectedPoints().toString().split(",")
		

        let arrangedList=[]

        //console.log("tab index from props:",props.tabIndex,tabIndex);
        var tabIndex = Provider.getGrowthTab()

   

		if (props.tabIndex) tabIndex = props.tabIndex

		let largeGreenDotOrder = 0
		
        if (scoreList.length > 0)
            for (var i = 0; i < scoreList.length; i++) {
               
				var oneFund = scoreList[i];
                if (tabIndex == 0 && i < scoreList.length / 4) {
                    oneFund.fill = '#007A53'
                    oneFund.quartile = 100
					largeGreenDotOrder++
					oneFund.greenDotOrder = largeGreenDotOrder
					// Might add some more meta data here to try and properly draw the labels, depends on what client wants
					tickerLookup[largeGreenDotOrder] = {
						ticker: scoreList[i].ticker,
						name: scoreList[i].display
					}
					
                } else if (tabIndex == 1 && i < scoreList.length / 2) {
                    oneFund.fill = '#007A53'
                    oneFund.quartile = 100
					largeGreenDotOrder++
					oneFund.greenDotOrder = largeGreenDotOrder
					// Might add some more meta data here to try and properly draw the labels, depends on what client wants
					tickerLookup[largeGreenDotOrder] = {
						ticker: scoreList[i].ticker,
						name: scoreList[i].display
					}
                } else if (tabIndex == 2) {
                    var index = selectedPoints.findIndex(ticker => ticker == oneFund.ticker)
                    if (index != -1) {
                        oneFund.fill = '#007A53'
                        oneFund.quartile = 100
						largeGreenDotOrder++
						oneFund.greenDotOrder = largeGreenDotOrder
						// Might add some more meta data here to try and properly draw the labels, depends on what client wants
						tickerLookup[largeGreenDotOrder] = {
							ticker: scoreList[i].ticker,
							name: scoreList[i].display
						}
                    } else {
                        oneFund.quartile = 10
                        oneFund.fill = '#000000'
                    }
                }
                else {
                    oneFund.quartile = 10
                    oneFund.fill = '#000000'
                }
                arrangedList.push(oneFund)
            }
        //console.log("all finalList for chart:", arrangedList);
		totalLarge = largeGreenDotOrder

        let finalList = _.sortBy(arrangedList, (point) => {
			return +(point.Drawdown)
        })

        //console.log("all finalList for chart:", finalList);
        setFinalList(finalList)
    }

    if (finalList.length === 0) {
        return (
            <div className="chart-placeholder">
                Add Funds to Compare Equity Allocations
            </div>
        )
    } else {
        if (showPicker && props.tabIndex == 2 ) {
           
			return <div>
                <Select
                    mode="multiple"
                    style={{ width: '100%', marginTop: '20px' }}
                    placeholder="Please select funds"
                    defaultValue={Provider.getSelectedPoints()}
                    onChange={(e) => setSelectedPoints(e)}
                    optionLabelProp="label"
                >
                    {
                        finalList.reduce((acc,ele) => {
							//Provider.getFunds()
							if (Object.keys(Provider.getFunds()).indexOf(ele.id) > -1) {
								acc.push (<Option value={ele.ticker} label={ele.ticker}>
									<div className="demo-option-label-item">
										<span role="img" aria-label="Growth" className='fund-ticker'>
											{ele.ticker}:
										</span>
										{ele.display}
									</div>
								</Option>)
							}

							return acc
                        },[])
                    }
                </Select>
                <div className='row center-end apply-btn'>
                    <Button type="primary" onClick={() => applySelection()}>Apply</Button>
                </div>
            </div>
        }
        return (
            <div>
				<div className="tooltip-container">
                    <ResponsiveContainer height={380} width="100%" id={props.id || 'GrowthChart'}>
                        <ScatterChart margin={{ top: 15, right: 20, left: 0, bottom: 25 }}>
                            <XAxis
                                label={{ value: "Drawdown Risk Near Retirement (Avg Max Drawdown)", position: 'bottom', offset: 5 }}
                                padding={{ left: 10, right: 10 }} unit="%" dataKey="Drawdown_X" allowDuplicatedCategory={false}
                                type="number" ticks={[12,13,14,15,16,17,18,19,20,21]} domain={[12,21]} allowDataOverflow={true}
                            />
                            <YAxis
                                label={{ value: "Growth Potential (Average Equity)", position: 'center', offset:10,  angle: -90 }}
                                dataKey="Growth_Y" unit="%" ticks={[40,50,60,70,80]} domain={[40,80]}
                            />
                            <ZAxis range={[10, 100]} dataKey="quartile" />
                            <CartesianGrid />
                            <Scatter data={finalList} name="Growth" onMouseEnter={showTooltip}
                                onMouseLeave={hideTooltip} activeShape={<Dot r={4} />}>
                                {finalList.map((fund, index) => (
                                    <Cell
                                        key={fund.id}
                                        fill={fund.fill ?? "#000000"}
                                    />
                                ))}

								<LabelList content={<CustomizedLabel  />}  offset="10"/>
								
                            </Scatter>
                        </ScatterChart>
                    </ResponsiveContainer>
                    {tooltip.show && (
                        <CustomTooltip
                            onMouseEnter={() => {
                                clearTimeout(tooltipTimeout);
                            }}
                            onMouseLeave={() => {
                                setTooltip({ show: false });
                                clearTimeout(tooltipTimeout);
                            }}
                            {...tooltip}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default GrowthChart;